

































import FooterButton from '@/components/FooterButton.vue' 
import { Component, Mixins} from 'vue-property-decorator'
import { ContentService } from "@/service/content.service";
import { StartApplicationContent } from "@/models/content/start-application";
import CommonMixin from "@/mixins/common-mixins";
import { AppData } from "@/models/app-data";

@Component({
  components: {
    FooterButton
  }
})
export default class StartApplication extends Mixins(CommonMixin) {
  content: StartApplicationContent = {} as StartApplicationContent;
  textDirection = "ltr";
  appData = {} as AppData;

  async mounted(): Promise<void> {
    const contentService = new ContentService(this.$route);
    this.content = await contentService.getStartApplicationContent();
    this.textDirection = contentService.TextDirection()
    this.appData = this.getAppData();
    if (this.appData != null && this.appData.workflowId != null) {
      await this.putWorkflowStep( this.appData.workflowId, "StartApplication")     
    }
  }

  public handleNextPageEvent(): void {
    this.$router.push({path:'StartApplicationPickPrograms'})
  }
}
